import AddEditProduct from './AddEditProduct';

export default AddEditProduct;
